import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import SuspenseLoader from "./components/SuspenseLoader.tsx";
import "./i18n";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const App = lazy(() => import("./App"));

createRoot(document.getElementById("root")!).render(
  <Suspense fallback={<SuspenseLoader />}>
    <App />
  </Suspense>
);
